import { Box, Button, Image, Input, Text } from "@mantine/core";
import Background from "../../assets/background-blur.svg";
import Layout from "../../components/home/layout";
import classes from "./styles.module.css";

export function VerifyPage() {
  return (
    <Layout>
      <Image className={classes.background} src={Background} />
      <Box className={classes.container}>
        <Box className={classes.card}>
          <Box className={classes.icon}></Box>
          <Text className={classes.title}>Баталгаажуулах код</Text>
          <Text className={classes.bodyText}>Таны бүртгэлтэй дугаар-руу явуулсан 6 оронтой тоог доорх талбарт оруулж мэдээлэлээ баталгаажуулна уу</Text>
          <Input className={classes.input} radius={8} size="lg" placeholder="Баталгаажуулах код" />
          <Button variant="gradient" radius={8} size={"lg"} className={classes.button} gradient={{ from: "#36B1ED", to: "#7165FA" }}>
            Баталгаажуулах
          </Button>
        </Box>
        <Box className={classes.bottomText}>© Голомт Банк, бүх эрх хуулиар хамгаалагдсан. 2023</Box>
      </Box>
    </Layout>
  );
}
